export default __webpack_public_path__ + "static/media/calculator.c87c4171.svg";